import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";
import defaultImg from "../../../assets/default.png";

interface TimeTableItem {
    periodId?: string;
    timeTableId?: string;
    clss?: string;
    subject?: string;
    period?: string;
    incharge?: string;
    inchargeId?: string;
    inchargeImage?: string;
    day?: string;
    time?: string;
}

const days = ["All", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const Timetable: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDay, setSelectedDay] = useState("All");
    const [timetableData, setTimetableData] = useState<Record<string, TimeTableItem[]>>({});
    const [attachmentUrl, setAttachmentUrl] = useState<string | null>(null);
    const [selectedAttachment, setSelectedAttachment] = useState<string | null>(null);

    useEffect(() => {
        Timetable();
    }, []);

    const Timetable = async () => {
        setIsLoading(true);
        try {
            const res = await serviceApi.get(environment.timetable);

            if (res?.status === "SUCCESS") {
                setTimetableData(res?.objectData || {});
                setAttachmentUrl(res?.url || null);
            }
        } catch (err) {
            console.error("Timetable fetch error", err);
        } finally {
            setIsLoading(false);
        }
    };

    const getFilteredData = () => {
        return timetableData[selectedDay] || [];
    };

    const data = getFilteredData();
    const isListEmpty = data.length === 0;

    return (
        <div className="notification-page">
            <h2 className="title-text notification-heading">Timetable</h2>
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Loading timetable...</span>
                    </div>
                </div>
            )}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", margin: "10px 12px" }}>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {days.map((day) => (
                        <button
                            key={day}
                            onClick={() => setSelectedDay(day)}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "20px",
                                border: "none",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: "600",
                                background: selectedDay === day ? "var(--colorPrimaryDark)" : "#eee",
                                color: selectedDay === day ? "#fff" : "#333",
                            }}
                        >
                            {day}
                        </button>
                    ))}
                </div>
                {attachmentUrl && !isListEmpty && (
                    <img
                        src={attachmentUrl}
                        onClick={() => setSelectedAttachment(attachmentUrl)}
                        style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "6px",
                            objectFit: "cover",
                            cursor: "pointer",
                            border: "1px solid #ddd",
                        }}
                    />
                )}
            </div>
            {attachmentUrl && isListEmpty && (
                <div
                    style={{
                        margin: "10px 12px",
                        padding: "10px",
                        background: "#fff",
                        borderRadius: "10px",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                >
                    <img
                        src={attachmentUrl}
                        alt="timetable-full"
                        style={{
                            width: "70%",
                            height: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            display: "block",
                        }}
                    />
                </div>
            )}
            <div style={{ padding: "10px 12px" }}>
                {data.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            background: "#fff",
                            borderRadius: "10px",
                            padding: "10px 12px",
                            marginBottom: "10px",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ fontWeight: 700, color: "var(--colorPrimaryDark)" }}>
                                Period {item.period || "-"}
                            </span>
                            <span style={{ fontSize: "12px", fontWeight: 600 }}>
                                {item.time || "-"}
                            </span>
                        </div>
                        <div style={{ height: "1px", background: "#eee", margin: "6px 0" }} />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "12px",
                                color: "#444",
                            }}
                        >
                            <img
                                src={item.inchargeImage || defaultImg}
                                alt="incharge"
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                }}
                            />
                            <span>{item.incharge || "-"}</span>
                        </div>
                        <div
                            style={{
                                marginTop: "6px",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            {/* LEFT: SUBJECT + THUMBNAIL */}
                            <div style={{ display: "flex", alignItems: "center", flex: 1, gap: "8px" }}>
                                <span
                                    style={{
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        color: "var(--colorAccent)",
                                    }}
                                >
                                    {item.subject || "-"}
                                </span>
                            </div>

                            {/* RIGHT: CLASS */}
                            <span
                                style={{
                                    fontWeight: 600,
                                    fontSize: "13px",
                                    color: "var(--colorAccent)",
                                }}
                            >
                                {item.clss || "-"}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            {selectedAttachment && (
                <div
                    onClick={() => setSelectedAttachment(null)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.75)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    {/* MODAL BOX */}
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: "relative",
                            background: "#fff",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90%",
                            maxHeight: "90%",
                        }}
                    >
                        {/* CLOSE BUTTON INSIDE IMAGE BOX */}
                        <button
                            onClick={() => setSelectedAttachment(null)}
                            style={{
                                position: "absolute",
                                top: "8px",
                                right: "8px",
                                background: "rgba(0,0,0,0.7)",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: "28px",
                                height: "28px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <span style={{ fontSize: "18px", lineHeight: "18px" }}>×</span>
                        </button>

                        {/* IMAGE */}
                        <img
                            src={selectedAttachment}
                            alt="attachment-full"
                            style={{
                                maxWidth: "80vw",
                                maxHeight: "80vh",
                                borderRadius: "8px",
                                display: "block",
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Timetable;